import React from 'react'

import { POPUP_TYPE } from '@Root/contants/popup'
import AlarmCompletePopup from '@Components/alarm/popup/AlarmCompletePopup'
import AlarmConfirmPopup from '@Components/alarm/popup/AlarmConfirmPopup'
import AlarmNotExposePopup from '@Components/alarm/popup/AlarmNotExposePopup'
import AlarmTradeContinuePopup from '@Components/alarm/popup/AlarmTradeContinuePopup'
import AlarmArticleCompleteTradeCancelPopup from '@Components/alarm/popup/AlarmArticleCompleteTradeCancelPopup'
import AlarmArticleExposureTradeCancelPopup from '@Components/alarm/popup/AlarmArticleExposureTradeCancelPopup'
import AlarmRequestFailPopup from '@Components/alarm/popup/AlarmRequestFailPopup'
import AlarmRequestSuccessPopup from '@Components/alarm/popup/AlarmRequestSuccessPopup'
import AlarmTradeCompletePopup from '@Components/alarm/popup/AlarmTradeCompletePopup'
import AlarmModifyCancelPopup from '@Components/alarm/popup/AlarmModifyCancelPopup'
import AlarmNotAccessArticleExposureConfirmPopup from '@Components/alarm/popup/AlarmNotAccessArticleExposureConfirmPopup'

type Props = {
  popupKey: POPUP_TYPE
}
const AlarmPopupFactory: React.FC<Props> = ({ popupKey }: Props) => {
  return (
    <>
      {popupKey === POPUP_TYPE.ALARM_CONFIRM && <AlarmConfirmPopup />}
      {popupKey === POPUP_TYPE.ALARM_NOT_EXPOSE && <AlarmNotExposePopup />}
      {popupKey === POPUP_TYPE.ALARM_COMPLETE && <AlarmCompletePopup />}
      {popupKey === POPUP_TYPE.ALARM_TRADE_COMPLETE && <AlarmTradeCompletePopup />}
      {popupKey === POPUP_TYPE.ALARM_TRADE_CONTINUE && <AlarmTradeContinuePopup />}
      {popupKey === POPUP_TYPE.ALARM_ARTICLE_COMPLETE_TRADE_CANCEL && <AlarmArticleCompleteTradeCancelPopup />}
      {popupKey === POPUP_TYPE.ALARM_ARTICLE_EXPOSURE_TRADE_CANCEL && <AlarmArticleExposureTradeCancelPopup />}
      {popupKey === POPUP_TYPE.ALARM_MODIFY_AGENT && <AlarmRequestSuccessPopup />}
      {popupKey === POPUP_TYPE.ALARM_MODIFY_CANCEL && <AlarmModifyCancelPopup />}
      {popupKey === POPUP_TYPE.ALARM_EXPOSURE_END && <AlarmRequestSuccessPopup />}
      {popupKey === POPUP_TYPE.ALARM_CHANGE_TRADE_COMPLETE && <AlarmRequestSuccessPopup />}
      {popupKey === POPUP_TYPE.ALARM_EXPOSURE_END_BY_TRADE_COMPLETE && <AlarmRequestSuccessPopup />}
      {popupKey === POPUP_TYPE.ALARM_CONTINUE_EXPOSURE && <AlarmRequestSuccessPopup />}
      {popupKey === POPUP_TYPE.ALARM_REQUEST_FAIL && <AlarmRequestFailPopup />}
      {popupKey === POPUP_TYPE.ALARM_NOT_ACCESS_ARTICLE_EXPOSURE_CONFIRM && <AlarmNotAccessArticleExposureConfirmPopup />}
    </>
  )
}

export default AlarmPopupFactory
